module.exports = __webpack_public_path__ + "static/media/Etheridge.848f32e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Etheridge.jpg
// module id = 620
// module chunks = 0